import React from 'react';
import * as Yup from 'yup';
import { FormHandles } from '@unform/core';
import uuid from '../../UniqueHash';
import { useModal } from '../../../../../../hooks/Modal';
import FormComponent, { sanitizeDataObject } from '../../FormComponentUnique';
import { createSchemaByForm, IYup } from '../../../../../../utils/SchemaCreator';
import getValidationErrors from '../../../../../../utils/getValidationErrors';
import api from '../../../../../../services/api';
import { useToast } from '../../../../../../hooks/Toast';
import { useSearch } from '../../../../../../hooks/Search';
import { AxiosInstance } from 'axios';
import { FaPlus, FaUpload } from 'react-icons/fa';
import { useParams } from 'react-router-dom';
import { useAuth } from '../../../../../../hooks/Auth';
import { Form } from '@unform/web';
import SelectSimple from '../../Forms/SelectSimple';
import { useConfiguration } from 'src/hooks/Configuration';
import { useLoading } from 'src/hooks/LoadingHook';
import { convertToXLSX } from 'src/utils/download';
import { hash } from 'src/config';

interface ICreateModule {
  lineData: Record<string, any>;
}

interface IParams {
  projectHash: string;
  eventHash: string;
}


const header = [
  {label: 'NOME', name: 'name'},
  {label: 'E-MAIL', name: 'email'},
  {label: 'DOCUMENTO', name: 'document_number'},
  {label: 'TELEFONE', name: 'phone'},
  {label: 'CATEGORIA', name: 'category_id'},
  {label: 'EMPRESA', name: 'company'},
  {label: 'CARGO', name: 'position'},
  {label: 'CIDADE', name: 'city'},
  {label: 'ESTADO', name: 'state'},
  {label: 'PAÍS', name: 'country'},
  {label: 'CORINGA', name: 'extra_1'},
]

export default function CreateModule() {
  const {addLoading, removeLoading} = useLoading();
  const { reloadSearchAll } = useSearch();
  const { addModal, removeModal } = useModal();
  const {configuration} = useConfiguration();
  const { addToast } = useToast();
  const { projectHash, eventHash } = useParams<IParams>();
  const { user } = useAuth();
  const key = uuid();


    const exportExample = () => {

    const listExport : Array<string> = [];
    header.map((item) => {

      listExport.push(item?.label)
    })

    convertToXLSX([listExport] )

  }
  
    const addParticipants = async (data, list) => {
  
      if (!data?.product_id) {
        addToast({ title: 'Insira um produto', type: 'error' });
        return;
      }
  
      data.term = 'Criado no credenciamento';
      data.extra_5 = 'Criado no credenciamento';


      let x = 0;

      while( x < list?.length){

        const item = list[x];
        item.product_id = data?.product_id;
         item.term = 'Criado no credenciamento';
      item.extra_5 = 'Criado no credenciamento';

await api.post(`/create-user-credentiate/${configuration?.url}`, item);
addToast({title: `${x+1}/${list?.length} - ${item?.name}`, type:'info'})

        x += 1;
      }
       
        addToast({title: `Upload finalizado`, type: 'success'})
        reloadSearchAll();
        removeModal('upload2')
     
     
  
    }

  const setCallback = async (
    data: Record<string, any>,
    formRef: React.RefObject<FormHandles>,
  ): Promise<void> => {
   
      const formData = new FormData();
      formData.append('file', data.image)
     
    const dataList = await api.post(`/converter/xlsx-to-json`, formData);
 const listItems: Array<Record<string,any>> = [];
    dataList?.data?.rows?.map(i => {

      const itemValue = {};

      Object.keys(i)?.map( itemKey => {


        const findItemList = header?.find(label => label?.label ===  itemKey);
if(findItemList){
itemValue[findItemList?.name] = i[itemKey];

}

      })


listItems.push(itemValue)
    })

        const products = await api.get(`/products-manager`,{params: { where: { project_id : configuration?.url}}});
    
        const productsList: Array<any> = [];
        products?.data?.rows?.map(i => {
          productsList.push({ label: i?.title, value: i?._id?.toString() })
        })
    


    removeModal('upload');
 const keyModal = addModal({ title: 'Adicionar Participantes', content:<>
 <div className='column gap  full-width'>


<div className='row gap  full-width'>

    <Form className='column gap full-width' style={{minWidth:'300px', maxWidth:'400px'}} onSubmit={(data) => addParticipants(data, listItems)} initialData={{ product_id: configuration?.current_event_id_response?.product_id }}>
        <p style={{textAlign:'center', width: '100%', fontSize:'12px', fontWeight:'bold', color: '#333'}}>Selecione um produto</p>
        <SelectSimple name='product_id' label='Ingresso' options={productsList || []} />

<button className='greenButton2'  >Adicionar Participantes</button>
 </Form>
</div>
<div className='column'>
  <p style={{textAlign:'center', width: '100%', fontSize:'12px', fontWeight:'bold', color: '#333'}}>Dados dos participantes para importação</p>
       
  <table className='tableRef full-width'>
  <tbody>
<tr>
      {header?.map( item => {
        return <td>{item?.label}</td>
      })}

      </tr>

      {listItems?.map( itemUpload => {

            return <tr>{header?.map( item => {

              return <td>{itemUpload?.[item?.name] || ''}</td>

           })}
            </tr>
 }

       )}

  </tbody>

  </table>


</div>

 </div>
 
 
 </>, key: 'upload2', theme: "whiteModal" });


  };

  const handleCreate = (): void => {
    const content = (<div className='column full-width gap'>
      <button className='greenButton2' onClick={() => exportExample()}  >Download de Modelo de Excel</button>
      <FormComponent schema={{
        image: {
          model: 'uploadImage',
          type: 'upload',
          name: 'image',
          label: 'Imagem',
        }
      }} setCallback={setCallback} /></div>
    );
    if (content) {
      const keyModal = addModal({ title: 'Adicionar usuários', content, key, theme: "whiteModalMini" });
    }
  };

  const moduleCreate = (): JSX.Element => (
    user && user?.profile === 1 ? <button className="searchButton" type="button" onClick={handleCreate}>
      <FaUpload />
    </button> : <></>
  );

  return moduleCreate();
}
